import {
  AuditTrailAuthEventType,
  AuditTrailDownloadEventRecordType,
} from "@libs/api/patients";
import { HTTPStatusCode } from "@libs/api/types";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const AuditTrailsApi = {
  recordAuthEvent: async (eventType: AuditTrailAuthEventType) => {
    const rest = await tsRestClient().auditTrails.recordAuthEvent({
      body: {
        type: eventType,
      },
    });

    if (rest.status === HTTPStatusCode.CREATED) {
      return;
    }

    sendSentryError({
      error: rest.body,
      message: `Failed to record audit trail auth event: ${eventType}`,
      shouldThrowError: false,
    });
  },
  recordDownloadEvent: async (body: {
    type: AuditTrailDownloadEventRecordType;
    id: string;
  }) => {
    const rest = await tsRestClient().auditTrails.recordDownloadEvent({
      body,
    });

    if (rest.status === HTTPStatusCode.CREATED) {
      return;
    }

    sendSentryError({
      error: rest.body,
      message: `Failed to record audit trail download event: ${body.type}`,
      shouldThrowError: false,
    });
  },
};
